<template>
 <!--找车说明 -->
  <el-dialog  :title="flag==1?'承运商竞价规则告知':'货主竞价规则告知'"  :visible.sync="dialog" width="900px"  @close="closeDialog" :close-oni-click-modal="false" :close-on-press-escape="false" center>
    <div v-if="flag==1">
      <p>更新时间：2022年5月25日</p>
      <p>生效时间：2022年5月25日</p>
      <p>亲爱的承运商用户货主好，感谢使用中物物流找车系统！以下为竞价规则，请货主知晓：</p>
 <p>货主将采用两种方式接单：竞价、抢单</p>
<h6>1、竞价规则</h6>
   <h6>（1）发布货源</h6>
<p>货主发布货源时，设置竞价要求，包括：计价方式、最高限价、最低限价，竞价结束时间等；系统将按照货主设置的竞价要求，将信息推送给货主选择的承运商范围。
     竞价失败：如果超过竞价结束时间时，仍没有人报价，则为竞价失败，请货主重新下单。</p>
   <h6>（2）承运商报价</h6>
如果您属于货主选择的承运商范围，则会收到该货源信息，您可以在【货源中心】-【竞价货源】进行报价，仅报价运费部分，不包含具体杂费。报价时不得超过最高限价，不得低于最低限价。
   <h6>（3）货主比价</h6>
系统将报价的承运商，按照总费用最低到最高的顺序排列，货主可以自主选择货主需要的承运商。选择后，视为双方均认可该运费价格。
   <h6>（4）确定承运商</h6>
比价后，承运商即确定。找车成功！
   <h6>（5）作废</h6>
如果货主在竞价中，包括：待竞价、待比价状态下，可对竞价单进行作废，重新下单。
   <h6>（6）查看竞价单</h6>
承运商报价后，所有竞价单，均可在【我的竞价】里查看报价进度。
<h6>2、抢单规则</h6>
  <h6> （1）发布货源</h6>
 <p>货主通过发布抢单货源，设置抢单要求，包括：计价方式、抢单价格、抢单间隔时间、加价间隔金额、最高金额。发布后，系统会自动推动给对应承运商。</p>
 <p>抢单金额：发布完成后，系统将自动根据抢单价格推送给承运商，如果到达间隔时间，仍没有承运商报价，则系统自动加价，在原基础上加价“加价间隔金额”，直到有承运商抢单成功。 </p>
 <p>抢单失败：如果超过抢单结束时间，仍然没有承运商抢单，则抢单失败，需要重新发布货源。</p>
<h6>（2）	承运商抢单</h6>
承运商按照当时抢单价格在【货源中心】-【抢单货源】进行抢单，抢单价格会根据设定自动加价，最高不超过货主设定的最高价格。抢单后视为同意该价格。
<h6>（3）	确定承运商</h6>
承运商抢单成功后，视为双方均认可该运费价格。
<h6>（4）	作废</h6>
如果货主在抢单中，包括：待抢单、抢单成功状态下，可对抢单货源进行作废，重新下单。
   <h6>（5）查看抢单进度</h6>
承运商接单后，所有抢单货源，均可在【我的抢单】里查看抢单进度。
感谢您的关注!

    </div>
    <div v-else>
      <p>更新时间：2022年5月25日</p>
      <p>生效时间：2022年5月25日</p>
亲爱的货主用户您好，感谢使用中物物流找车系统！以下为竞价规则，请您知晓：<br>
您将采用两种方式寻找承运商：竞价、抢单
<h6>1、	竞价规则</h6>
   <h6>（1）发布货源</h6>
     <p>您发布货源时，设置竞价要求，包括：计价方式、最高限价、最低限价，竞价结束时间等；系统将按照您设置的竞价要求，将信息推送给您选择的承运商范围；</p>
     <p>竞价金额：系统会自动根据您填写的运费区间、杂费，自动计算应缴纳找车服务费（含税）、总费用。找车服务费按照一单50元进行收取，以最新收费标准为准。点击发布货源后，视为货主认同收费。</p>
     <p>竞价失败：如果超过竞价结束时间时，仍没有人报价，则为竞价失败，请您重新下单。</p>
   <h6>（2）承运商报价</h6>
发布给您选择的承运商范围后，承运商进行报价，仅报价运费部分，不包含具体杂费。
  <h6> （3）货主比价</h6>
系统将报价的承运商，按照最低到最高的顺序排列，您可以自主选择您需要的承运商。
  <h6> （4）确定承运商</h6>
比价后，承运商即确定。找车成功！
  <h6> （5）作废</h6>
如果您在竞价中，包括：待竞价、待比价状态下，可对竞价单进行作废，重新下单。
   <h6>（6）查看竞价单</h6>
您发布后，所有竞价单，均可在【我的竞价】里查看报价进度。
<h6>2、抢单规则</h6>
    <h6>（1）发布货源</h6>
 <p>您通过发布抢单货源，设置抢单要求，包括：计价方式、抢单价格、抢单间隔时间、加价间隔金额、最高金额。发布后，系统会自动推动给对应承运商。</p>
 <p>抢单金额：发布完成后，系统将自动根据抢单价格推送给承运商，如果到达间隔时间，仍没有承运商报价，则系统自动加价，在原基础上加价“加价间隔金额”，直到有承运商抢单成功。</p>
 <p>抢单失败：如果超过抢单结束时间，仍然没有承运商抢单，则抢单失败，需要重新发布货源。</p>
<h6>（2）	承运商抢单</h6>
承运商按照当时抢单价格进行抢单，抢单价格会根据设定自动加价，最高不超过货主设定的最高价格。
<h6>（3）	确定承运商</h6>
承运商抢单成功后，自动根据当时抢单时的抢单价格，作为协议价格。
<h6> （4）	作废</h6>
如果您在抢单中，包括：待抢单、抢单成功状态下，可对抢单货源进行作废，重新下单。
   （5）查看抢单进度</h6>
您发布后，所有抢单货源，均可在【我的抢单】里查看抢单进度。
<h6>3、	费用和开票</h6>
   <h6>（1）支付找车费</h6>
货主成功找到承运商后，将会在【支付运费】出现一条找车应收费用，货主可在此页面支付找车费用，支付后可开具发票。
<h6>（2）	开票</h6>
货主可在【财务管理】-【发票管理】选择需要开的发票，生成发票包，然后在【发票申请】缴纳邮费后，进行申请，平台收到邮费后，会及时开具和邮寄发票事宜。
感谢您的关注!

    </div>
     <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
      </span>
   </el-dialog>

</template>

<script>
export default {
  name: 'lookVoucher',
  props: ['flag'],
  data () {
    return {
      dialog: true

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM

  },
  methods: {
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
